import Box from "@mui/material/Box";

import CustomTable from "components/shared/table";
import { InputBatchConfigFormat } from "pages/geoscape-batch/types";
import { Dispatch, SetStateAction, useMemo } from "react";
import { buildInputColumns } from "./columns-row";
import { addIndex } from "./utils";

interface MappingTableInputProps {
  inPutParameters: InputBatchConfigFormat[];
  setInPutParameters: Dispatch<SetStateAction<InputBatchConfigFormat[]>>;
}

type IndexedInputBatchConfigFormat = InputBatchConfigFormat & { index: number };

const MappingTableInput = ({
  inPutParameters,
  setInPutParameters,
}: MappingTableInputProps) => {
  const columns = useMemo(
    () => buildInputColumns({ setInPutParameters }),
    [setInPutParameters],
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        marginTop: "16px",
      }}
    >
      <CustomTable
        rows={addIndex(inPutParameters)}
        columns={columns}
        isLoading={false}
        overlayText=""
        getRowId={(row: IndexedInputBatchConfigFormat) => String(row.index)}
      />
    </Box>
  );
};

export default MappingTableInput;
